import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 公共上传类
import Upload from "@/components/management/file/Upload";
export default {
  name: "AddFile",
  props: [],
  components: {
    Upload: Upload
  },
  data: function data() {
    return {
      limit: 1,
      baseUrl: process.env.BASE_URL,
      title: "",
      show: false,
      loading: false,
      text: "",
      fileList: [],
      endFile: [],
      uploadFiles: [] // 每次要上传的文件

    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    finishUpload: function finishUpload(ids) {
      var _this = this;

      ids.forEach(function (e) {
        if (e.type === "error") {
          _this.$refs.upload.uploadFiles.splice(_this.$refs.upload.uploadFiles.findIndex(function (item) {
            return item.uid === e.uid;
          }), 1);
        } else {
          _this.endFile.push(e);
        }
      });
      setTimeout(function () {
        _this.loading = false;
        _this.text = "";
      }, 2000);
    },
    // 显示弹框
    showBox: function showBox(data) {
      var _this2 = this;

      this.show = true;
      this.endFile = [];
      this.$nextTick(function () {
        _this2.title = data.title;
        _this2.limit = data.limit;

        _this2.$refs.upload.clearFiles();

        _this2.$refs.uploader.clearFileList();
      });
    },
    // 上传
    upload: function upload() {
      var _this3 = this;

      this.loading = true;
      this.$nextTick(function () {
        _this3.text = "正在处理上传文件，请勿关闭窗口……";
        _this3.uploadFiles = _this3.$refs.upload.uploadFiles; // 处理上一次上传过的文件

        _this3.endFile.forEach(function (e) {
          _this3.uploadFiles.splice(_this3.uploadFiles.findIndex(function (item) {
            return item.uid === e.uid;
          }), 1);
        });

        _this3.$refs.uploader.addFiles(_this3.uploadFiles.map(function (val) {
          return val.raw;
        }));
      });
    },
    //获取文件id
    getFileId: function getFileId() {},
    submitFn: function submitFn() {},
    onChange: function onChange(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed: function handleExceed() {
      this.$message.warning("当前限制选择 " + this.limit + " 个文件");
    },
    // 关闭
    closeFn: function closeFn() {
      this.show = false;
      this.fileList = [];
      this.$refs.uploader.show = false;
      this.$parent.initPage();
    }
  },
  watch: {},
  filters: {}
};